import Vue from 'vue';
import Vuex from 'vuex';
import Fullpage from './modules/Fullpage/Fullpage';
import ClassSection from './modules/ClassSection/ClassSection';
import SummonSection from './modules/SummonSection/SummonSection';
import Animation from './modules/Animation/Animation';
import MenuNavMobile from './modules/MenuNavMobile/MenuNavMobile';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    Fullpage,
    ClassSection,
    SummonSection,
    Animation,
    MenuNavMobile,
  },
});
